import { createSelector } from 'reselect';
import _ from 'lodash';

const selectNewInstallationGroupItem = (state) => state.newInstallationGroupItem;

export const getActiveEditData = createSelector(
  [selectNewInstallationGroupItem],
  (item) => {
    return item.edit || {};
  }
);